/*
 * Package Import
 */
import styled from '@emotion/styled';

/*
 * Local Import
 */

/*
 * Style
 */
export const BadgeContainer = styled('div')((props) => ({
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '1.2rem',
  width: '1.2rem',
  ...props.theme.shadows.plus1, // Box Shadow
  backgroundColor: props.theme.background._2,
  borderRadius: '50%',
  top: '-0.5rem',
  right: '-0.7rem',
  zIndex: '1',
}));
